<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-05 17:07:37
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:56:17
 * @Description: file content
 -->
<template>
  <div class="index">
    <UserCard3></UserCard3>
    <SplitLine v-if="isShowGuide"></SplitLine>
    <LuckyStripe v-if="isShowGuide"></LuckyStripe>
    <SplitLine></SplitLine>
    <BlockTitle v-if="recommendList&&recommendList.length>0" :initName="'推荐项目'"></BlockTitle>
    <ScrollViewHorImg
      style="margin-top:-12px;"
      v-if="recommendList&&recommendList.length>0"
      :list="recommendList"
      @clickItem="clickScrollViewHorImgItem"
    ></ScrollViewHorImg>
    <!-- <PictureTextBlock></PictureTextBlock> -->
    <BlockTitle v-if="contentList&&contentList.length>0" :initName="'推荐内容'"></BlockTitle>
    <div class="contentList" v-if="contentList&&contentList.length>0" v-for="item in contentList">
      <ImgTextItem @clickItem="clickScrollViewHorImgItem" :item="item"></ImgTextItem>
    </div>
    <SplitLine v-if="isShowGuide"></SplitLine>
    <Iwantit v-if="isShowGuide"></Iwantit>
    <!-- <BubbleShare v-if="isShowBubbleShare" v-on:close="isShowBubbleShare=false"></BubbleShare> -->
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import request from "@/utils/request";
import "swiper/dist/css/swiper.css";
import { mapState, mapMutations } from "vuex";
import wx from "weixin-js-sdk";
import { swiper, swiperSlide } from "vue-awesome-swiper";
const UserCard3 = () => import("@/components/usercard3");
const LuckyStripe = () => import("@/components/lucky_stripe");
const BlockTitle = () => import("@/components/block-title");
const PictureTextBlock = () => import("@/components/picture-text-block");
const SplitLine = () => import("@/components/split-line");
const ScrollViewHorImg = () => import("@/components/scroll-view_hor_img");
const Iwantit = () => import("@/components/iwantit");
const ImgTextItem = () => import("@/components/img-text-item");
const BubbleShare = () => import("@/components/bubble_share");
export default {
  components: {
    swiper,
    swiperSlide,
    ScrollViewHorImg,
    UserCard3,
    LuckyStripe,
    BlockTitle,
    PictureTextBlock,
    SplitLine,
    Iwantit,
    ImgTextItem,
    BubbleShare
  },
  props: {},
  data() {
    return {
      recommendList: null,
      contentList: null,
      isShowBubbleShare: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    // 点击推荐项目
    clickScrollViewHorImgItem: function(item) {
      console.log("clickScrollViewHorImgItem", item);
      if (!item) {
        return;
      }
      util.openFound(this, item);
    },
    scrollEvent() {
      // console.log(
      //   `document.body.scrollTop:${document.body.scrollTop} this.$clientHeight:${this.$clientHeight} document.body.scrollHeight:${document.body.scrollHeight}`
      // );

      // if (this.$refs.refIwantit) {
      //   console.log(">>>>>>>>>>>>", this.$refs.refIwantit.$el.clientHeight);
      //   if (
      //     document.body.scrollHeight - this.$clientHeight >
      //     50 + this.$refs.refIwantit.$el.clientHeight
      //   ) {
      //   }
      // }

      if (document.body.scrollHeight - this.$clientHeight > 100) {
        let tmpNum =
          document.body.scrollHeight -
          this.$clientHeight -
          document.body.scrollTop;
        if (tmpNum < 100) {
          this.isShowBubbleShare = true;
        } else {
          this.isShowBubbleShare = false;
        }
      }
    }
  },
  created() {
    let that = this;
    util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
      comreq.listPageInfoWithChannel(that, 2, 0, 6).then(function(data) {
        if (util.isArray(data.list)) {
          that.recommendList = data.list.map(function(item) {
            item.img = item.wxsmallpic;
            item.phrase = item.title;
            return item;
          });
        } else {
          that.recommendList = [];
        }
        console.log("that.recommendList", that.recommendList);
      });
      comreq.listPageInfoWithChannel(that, 1, 0, 10).then(function(data) {
        if (util.isArray(data.list)) {
          that.contentList = data.list.map(function(item) {
            item.time = util.formatTime4(new Date(item.createtime));
            return item;
          });
        } else {
          that.contentList = [];
        }
        console.log("that.contentList", that.contentList);
      });
    });
    window.addEventListener("scroll", that.scrollEvent, true);
  },
  mounted() {}
};
</script>

<style lang="css" scoped>
.contentList {
  margin: 0 10px;
}
</style>